<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Avaliar Relatório Administrativo</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseReport')" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="4">
            <v-text-field
              v-model="report.municipio.nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="3">
            <v-text-field
              v-model="report.inicioString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00:00"
              disabled
            ></v-text-field>
          </v-col>

          <v-col sm="3">
            <v-text-field
              v-model="report.fimString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00:00"
              disabled
            ></v-text-field>
          </v-col>

          <v-col sm="2">
            <v-text-field
              v-model="report.horas"
              label="Horas Correspondentes"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-tabs vertical>
            <v-tab>
              <v-icon left>mdi-file-chart</v-icon>
              Relatório
            </v-tab>

            <v-tab>
              <v-icon left>mdi-attachment</v-icon>
              Anexos
            </v-tab>

            <v-tab-item>
              <v-col>
                <v-textarea v-model="report.descricao" readonly></v-textarea>
              </v-col>
            </v-tab-item>

            <v-tab-item>
              <v-data-table
                :headers="headersAnexos"
                :items="report.anexos"
                class="elevation-1"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.download="{ item }">
                  <v-btn
                    outlined
                    color="primary"
                    class="ml-3"
                    @click="downloadAnexo(item)"
                  >
                    <span>Download</span>
                  </v-btn>
                </template>

                <template slot="no-data">
                  <span> Nenhum anexo retornado </span>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              label="Motivo da rejeição"
              v-model="report.motivoRejeicao"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="$emit('onCloseReport')"
          >Fechar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(2)"
          v-if="isAdmin && report.statusRelatorioId !== 4"
          >Aprovar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(3)"
          v-if="isAdmin && report.statusRelatorioId !== 4"
          >Rejeitar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { administrativeReportAPI } from "@/modules/administrative-report";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalAnalyseReport",
  props: {
    dialog: { type: Boolean, default: false },
    id: { type: Number, required: false },
  },
  computed: {
    ...mapGetters(["isAdmin"]),
  },
  data() {
    return {
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      report: {
        arquivos: [],
        municipio: {},
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    save(statusId) {
      if (statusId === 3 && !this.report.motivoRejeicao) {
        this.$notification.error("Favor inserir o motivo da rejeição");
      } else {
        this.setLoading(true);
        this.report.statusRelatorioId = statusId;

        administrativeReportAPI
          .analyse(this.report)
          .then((resp) => {
            this.setLoading(false);
            this.$emit("onCloseReport");
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error(
              "Erro ao atualizar relatório administrativo"
            );
          });
      }
    },
    get() {
      this.setLoading(true);
      administrativeReportAPI
        .get(this.id)
        .then((resp) => {
          this.report = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório administrativo");
        });
    },
    downloadAnexo(evidencia) {
      administrativeReportAPI
        .downloadAnexo(evidencia.relatorioAdministrativoAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter anexo");
        });
    },
  },
  watch: {
    id: function () {
      this.get();
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
